export default "__VITE_ASSET__BoItRi1$__"